export default defineNuxtPlugin(() => {
  const router = useRouter()

  // reset game3 after navigating out of it
  router.afterEach((to, from) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [fromName, _fromLangage] = String(from.name).split('___')
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [toName, _toLangage] = String(to.name).split('___')

    if (!fromName.startsWith('game-3')) return
    if (toName.startsWith('game-3')) return

    useStoreGame3().$reset()
  })
})
